import React from 'react';
import { CheckboxInput } from '@guildeducationinc/recess';
import styles from './InterestCheckBox.module.scss';

export interface Props {
	label: string;
	popoverText: string;
	checked: boolean;
	onChange: () => void;
}

export const InterestCheckBox: React.FC<Props> = ({ label, popoverText, checked, onChange }) => {
	return (
		<div className={styles.checkboxButtonContainer}>
			<CheckboxInput
				additionalInfo={popoverText}
				aria-required={true}
				checked={checked}
				data-testid='interest-checkbox'
				label={label}
				onChange={onChange}
			/>
		</div>
	);
};
